import { getWindow } from '../../../utils/general';
export var ODTableHeaderData = function (tableHeaderState) {
    var _a, _b, _c, _d, _e;
    return [
        {
            title: 'Date Created',
            style: { width: '125px', paddingLeft: '16px' },
            sort: false,
            showHeader: (_a = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[0]) === null || _a === void 0 ? void 0 : _a.enabled,
        },
        {
            title: 'Order #',
            style: { width: '141px', paddingLeft: '16px' },
            sort: false,
            showHeader: (_b = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[1]) === null || _b === void 0 ? void 0 : _b.enabled,
        },
        {
            title: 'Project',
            style: { width: '124px', padding: '0px 0 0px 16px' },
            sort: false,
            showHeader: (_c = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[2]) === null || _c === void 0 ? void 0 : _c.enabled,
        },
        {
            title: 'PO/Job Name',
            style: { width: '124px', paddingLeft: '16px' },
            sort: false,
            showHeader: true,
        },
        {
            title: 'Status',
            style: { width: '110px', paddingLeft: '16px' },
            sort: false,
            showHeader: true,
        },
        {
            title: 'Exception',
            style: { width: '155px', paddingLeft: '16px' },
            sort: false,
            showHeader: (_d = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[5]) === null || _d === void 0 ? void 0 : _d.enabled,
        },
        {
            title: 'Delivery Date',
            style: { width: '122px', textAlign: 'left', paddingLeft: '16px' },
            sort: false,
            showHeader: (_e = tableHeaderState === null || tableHeaderState === void 0 ? void 0 : tableHeaderState[6]) === null || _e === void 0 ? void 0 : _e.enabled,
        },
    ];
};
export var ODTableHeaderValues = function () {
    var _a, _b, _c;
    var tableHeaderValuesLocalStorage = (_c = (_b = (_a = getWindow()) === null || _a === void 0 ? void 0 : _a.sessionStorage) === null || _b === void 0 ? void 0 : _b.getItem('tableHeaders')) !== null && _c !== void 0 ? _c : '';
    if (tableHeaderValuesLocalStorage !== '') {
        var tableHeaderValues = JSON === null || JSON === void 0 ? void 0 : JSON.parse(tableHeaderValuesLocalStorage);
        return tableHeaderValues;
    }
    return [
        {
            columnName: 'Date Created',
            enabled: true,
        },
        {
            columnName: 'Order #',
            enabled: true,
        },
        {
            columnName: 'Project',
            enabled: true,
        },
        {
            columnName: 'PO/Job Name',
            enabled: true,
        },
        {
            columnName: 'Status',
            enabled: true,
        },
        {
            columnName: 'Exception',
            enabled: true,
        },
        {
            columnName: 'Delivery Date',
            enabled: true,
        },
    ];
};
